@if (myFeeds(); as feeds) { @if (feeds.length === 0) {
<lib-message [type]="'noDataOnBody'">You have no notifications</lib-message>
} @if (feeds.length) {
<div>
	@for (feed of feeds; track feed.id; let first = $first) {
	<div [class.push-top]="!first">
		<lib-card
			[title]="feed.originUser?.fullName"
			[avatarName]="feed.originUser?.fullName ?? feed.feedType"
			[subtitle]="feed.fromNow"
			[avatar]="feed.originUser?.avatar"
		>
			<div libText1 libWordBreak [innerHTML]="feed.message | textToHtml"></div>
		</lib-card>
	</div>
	}
</div>
} }
